import { map } from 'lodash';
export const MONDAY = { id: 1, name: 'Monday', value: 'MON' };
export const TUESDAY = { id: 2, name: 'Tuesday', value: 'TUE' };
export const WEDNESDAY = { id: 3, name: 'Wednesday', value: 'WED' };
export const THURSDAY = { id: 4, name: 'Thursday', value: 'THU' };
export const FRIDAY = { id: 5, name: 'Friday', value: 'FRI' };
export const SATURDAY = { id: 6, name: 'Saturday', value: 'SAT' };
export const SUNDAY = { id: 7, name: 'Sunday', value: 'SUN' };
const Basic = [MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY, SUNDAY];
export const BasicByValue = Basic.reduce((hash, type) => {
    hash[type.value] = type;
    return hash;
}, {});
export const BasicById = Basic.reduce((hash, day) => {
    hash[day.id] = day;
    return hash;
}, {});
export const BasicValues = map(Basic, 'value');
export default {
    Basic,
    BasicByValue,
    BasicValues,
    BasicById,
    MONDAY,
    TUESDAY,
    WEDNESDAY,
    THURSDAY,
    FRIDAY,
    SATURDAY,
    SUNDAY,
};
